import * as actionsCommon from '@/store/actions'
import API from '@/api'

import * as actions from '../actions'
import { initialPagination } from '@/constants/pagination'
import { preparePagination } from '@/core'
import { showMessageSuccess } from '@/UI/message'

export default {
  state: {
    isLoading: false,
    exporters: [],
    exportersAll: [],
    pagination: initialPagination,
  },
  getters: {
    [actions.GET_EXPORTERS_FOR_TABLE]: state => state.exporters,
    [actions.GET_EXPORTERS_ALL]: state => state.exportersAll,
    [actions.GET_EXPORTERS_PAGINATION]: state => state.pagination,
    [actions.GET_IS_LOADING_EXPORTERS]: state => state.isLoading,
  },
  actions: {
    [actions.FETCH_EXPORTERS_ALL]({ commit, rootGetters }, id = null) {
      const terminalCurrentId = id
        ? id
        : rootGetters[actionsCommon.GET_TERMINAL_CURRENT_ID] || null
      const requestData = {
        unload_id: terminalCurrentId,
        page: 1,
        'per-page': 999,
      }

      if (terminalCurrentId) {
        commit(actions.SET_IS_LOADING_EXPORTERS, true)

        API.control.exporters
          .get(requestData)
          .then(({ data }) => commit(actions.SET_EXPORTERS_ALL, data))
          .catch(error => console.log('error', error))
          .finally(() => commit(actions.SET_IS_LOADING_EXPORTERS, false))
      }
    },
    [actions.FETCH_EXPORTERS_PAGE]({ commit, rootGetters }, payload) {
      const terminalCurrentId =
        rootGetters[actionsCommon.GET_TERMINAL_CURRENT_ID] || null
      const requestData = {
        unload_id: terminalCurrentId,
        ...payload,
      }

      if (terminalCurrentId) {
        commit(actions.SET_IS_LOADING_EXPORTERS, true)

        API.control.exporters
          .get(requestData)
          .then(({ headers, data }) =>
            commit(actions.SET_EXPORTERS_PAGE, {
              data,
              pagination: preparePagination(headers),
            }),
          )
          .catch(error => console.log('error', error))
          .finally(() => commit(actions.SET_IS_LOADING_EXPORTERS, false))
      }
    },
    [actions.SAVE_EXPORTER](
      { commit, dispatch, rootGetters },
      { requestData, callback, params },
    ) {
      const terminalCurrentId =
        rootGetters[actionsCommon.GET_TERMINAL_CURRENT_ID]
      const data = { unload_id: terminalCurrentId, ...requestData }

      // если пришел ИД - обновляем, если нет - создаем нового
      const method = requestData.id ? 'update' : 'create'

      if (terminalCurrentId) {
        commit(actions.SET_IS_LOADING_EXPORTERS, true)

        API.control.exporters[method](data)
          .then(({ data }) => {
            dispatch(actions.FETCH_EXPORTERS_PAGE, params)
            dispatch(actions.FETCH_EXPORTERS_ALL)
            showMessageSuccess(
              requestData.id
                ? 'Экспортер успешно изменен'
                : 'Экпортер успешно создан',
            )
            callback()
          })
          .catch(error => console.log('error', error))
          .finally(() => commit(actions.SET_IS_LOADING_EXPORTERS, false))
      }
    },
    [actions.DELETE_EXPORTERS](
      { commit, dispatch },
      { ids, callback, params },
    ) {
      commit(actions.SET_IS_LOADING_EXPORTERS, true)

      API.control.exporters
        .delete(ids)
        .then(() => {
          dispatch(actions.FETCH_EXPORTERS_PAGE, params)
          dispatch(actions.FETCH_EXPORTERS_ALL)
          showMessageSuccess(
            ids.length > 1 ? 'Экспортеры были удалены' : 'Экспортер был удален',
          )
          callback()
        })
        .catch(error => console.log('error', error))
        .finally(() => commit(actions.SET_IS_LOADING_EXPORTERS, false))
    },
  },
  mutations: {
    [actions.SET_IS_LOADING_EXPORTERS](state, payload) {
      state.isLoading = payload
    },
    [actions.SET_EXPORTERS_PAGE](state, { data, pagination }) {
      state.exporters = data
      state.pagination = pagination
    },
    [actions.SET_EXPORTERS_ALL](state, data) {
      state.exportersAll = data
    },
  },
}
